import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TabsMenuState {
    mobileTabsMenuExpanded: string | null;
}

const initialState: TabsMenuState = { mobileTabsMenuExpanded: null };

const tabsMenuSlice = createSlice({
    name: 'tabsMenu',
    initialState,
    reducers: {
        setMobileTabsMenuExpanded: (state, action: PayloadAction<string | null>) => {
            state.mobileTabsMenuExpanded = action.payload
        },
    }
})

export const { setMobileTabsMenuExpanded } = tabsMenuSlice.actions;

export default tabsMenuSlice.reducer;

export const selectMobileTabsMenuExpanded = (state: { tabsMenu: { mobileTabsMenuExpanded: string | null } }) => state.tabsMenu.mobileTabsMenuExpanded